export const MoneyDollarBoxIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 1.5V12.3333H12.3333V1.5H1.5ZM0 1.41667C0 0.635786 0.635786 0 1.41667 0H12.4167C13.1975 0 13.8333 0.635786 13.8333 1.41667V12.4167C13.8333 13.1975 13.1975 13.8333 12.4167 13.8333H1.41667C0.635786 13.8333 0 13.1975 0 12.4167V1.41667ZM6.16667 3.83333H5.75C4.68912 3.83333 3.83333 4.68912 3.83333 5.75C3.83333 6.81088 4.68912 7.66667 5.75 7.66667H8.08333C8.31579 7.66667 8.5 7.85088 8.5 8.08333C8.5 8.31579 8.31579 8.5 8.08333 8.5H4.58333V10H6.16667V10.9167H7.66667V10H8.08333C9.14421 10 10 9.14421 10 8.08333C10 7.02245 9.14421 6.16667 8.08333 6.16667H5.75C5.51755 6.16667 5.33333 5.98245 5.33333 5.75C5.33333 5.51755 5.51755 5.33333 5.75 5.33333H9.25V3.83333H7.66667V2.91667H6.16667V3.83333Z"
        fill="#006F43"
      />
    </svg>
  )
}
